import * as React from 'react';
import { useState } from 'react';

import Arrow from 'assets/icons/arrows/arrow-down-16.svg';

import { ActiveProposals } from 'components/Header/ActiveProposals/ActiveProposals';

import { Menu, MenuHead, MenuHeadTitle, MenuLinks, CountSlot } from './ExpandedMenu.styled';

interface Props {
    links: React.ReactNode;
    title: string;
    counts?: { active: number; discussion: number };
    indicator?: React.ReactNode;
}

const ExpandedMenu = ({ links, title, counts, indicator }: Props): React.ReactNode => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Menu
            data-testid={`header-menu-${title}`}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <MenuHead>
                <MenuHeadTitle>
                    {title}
                    {indicator}
                    {counts && (
                        <CountSlot>
                            <ActiveProposals
                                discussionCount={counts.discussion}
                                activeCount={counts.active}
                            />
                        </CountSlot>
                    )}
                </MenuHeadTitle>
                <Arrow />
            </MenuHead>
            <MenuLinks $isOpen={isOpen}>{links}</MenuLinks>
        </Menu>
    );
};

export default ExpandedMenu;
